<template>
  <div>
    <el-dialog
      :visible.sync="visble"
      width="1200px"
      :title="title"
      :close-on-click-modal="false"
    >
      <el-form
        inline
        label-suffix=":"
        label-width="120px"
        :model="queryForm"
        ref="form"
        :rules="rules"
        size="mini"
        :disabled="disabled"
      >
        <el-row>
          <el-col :span="24">
            <el-col :span="8">
              <el-form-item :label="`经销商名称`" prop="name">
                <el-input class="input230" v-model="queryForm.name" :placeholder="`请输入`"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="`联系人名称`">
                <el-input class="input230" v-model="queryForm.contact" :placeholder="`请输入`"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="`联系人电话`">
                <el-input class="input230" v-model="queryForm.mobile" :placeholder="`请输入`"></el-input>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col :span="24">
            <el-col :span="8">
              <el-form-item :label="`国家`" prop="country">
                <el-select
                  class="input230"
                  v-model="queryForm.country"
                  clearable
                  @change="changeCountry"
                  :placeholder="`请选择`"
                >
                  <el-option
                    v-for="item in countries"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="`地址`" prop="addressData">
                <el-cascader
                  v-model="queryForm.addressData"
                  :props="{
                    label: 'name',
                    value: 'code'
                  }"
                  popper-class="cascader-style"
                  class="input230"
                  :options="addressOptions"></el-cascader>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col :span="24">
            <el-col :span="8">
              <el-form-item :label="`经销商级别`">
                <el-select class="input230" v-model="queryForm.level" :placeholder="`请选择`">
                  <el-option
                    v-for="item in levels"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="`上级经销商`">
                <el-input class="input230" v-if="disabled && !queryForm.upper_dealer_id" value="无" :placeholder="`请输入`"></el-input>
                <el-select
                  v-else
                  class="input230"
                  v-model="queryForm.upper_dealer_id"
                  :placeholder="`请选择`"
                  filterable
                  clearable
                >
                  <el-option
                    v-for="item in dealerOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col :span="16">
            <el-form-item :label="`备注`">
              <el-input
                type="textarea"
                style="width: 620px"
                v-model="queryForm.remark"
                :maxlength="20"
                :placeholder="`请输入`"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div>
          <el-button @click="cancel">取消</el-button>
          <el-button type="primary" @click="submit">{{
            `确定`
          }}</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import store from '@/store'
import {
    getAddressData
} from '@/requests/system'
import { createDealer, dealerDetail, dealerSelect } from '@/api.js'
export default {
  data() {
    return {
      title: '新建经销商',
      visble: false,
      queryForm: {},
      editId: undefined,
      rules: {
        name: [
          {
            required: true,
            message: `请输入`,
            trigger: 'blur',
          },
        ],
        country: [
          {
            required: true,
            message: `请选择`,
            trigger: 'blur',
          },
        ],
        addressData: [
          {
            required: true,
            message: `请选择`,
            validator: (rule, value, callback) => {
              if (!value || !value.length) {
                callback(new Error(`地址不能为空`));
              } else {
                callback();
              }
            },
            trigger: 'blur',
          },
        ]
      },
      areaOpts: [], //区县list
      levels: [], //经销商等级
      disabled: false,
      dealerOptions:[], //经销商
      addressOptions: [],
    }
  },
  // props: {
  //   dealerOptions: {
  //     type: Array,
  //     default: () => [],
  //   },
  // },
  created() {
    // 字典
    this.$utils.getDict([610]).then((res) => {
      if (res) {
        this.levels = res[610]
      }
    })
  },
  computed: {
    ...mapGetters(['user', 'countries']),
  },
  methods: {
    // 获取经销商 (这里的经销商的获取不能在父组只获取一次，因为有可能在这个页面修改了经销商，如果只在父元素调用一次，会导致经销商不更新的bug)
    getDealerSelect(){
      this.$request('get', dealerSelect).then((res) => {
        this.dealerOptions = res
      })
    },
    async open(row, disabled) {
      this.getDealerSelect()
      await store.dispatch('setCountries')
      this.queryForm = {}
      this.disabled = !!disabled
      if (row) {
        this.title = `编辑`
        this.editId = row.id
        let url = dealerDetail.replace('{id}', row.id)
        this.$request('get', url).then((res) => {
          if (res) {
            this.queryForm = {...res}
            if (this.queryForm.upper_dealer_id == 0) {
              this.queryForm.upper_dealer_id = ''
            }

            const { country, province, city, area } = this.queryForm
            if (country) {
              this.getAddress(country)
            }

            const addressData = province && city
            ?
            [province, city] 
            :
            []

            if (area) {
              addressData.push(area)
            }

            if (addressData.length) {
              this.$set(this.queryForm, 'addressData', addressData)
            }
          }
        })
      } else {
        this.editId = undefined
        this.title = `新建`
        this.defaultCountry()
      }
      this.visble = true

      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    defaultCountry() {
      // 默认国家
      const defaultCountry = this.$store.state.countries && this.$store.state.countries[0].code
      this.$set(this.queryForm, 'country', defaultCountry)
      this.$nextTick(() => {
        this.changeCountry(defaultCountry)
      })
    },
    changeCountry(value) {
      this.$set(this.queryForm, 'addressData', [])
      this.$nextTick(() => { 
        this.addressOptions = []
        this.getAddress(value)
      })
    },
    getAddress(code) {
      if (!code) return

      getAddressData(code)
      .then(res => {
        const addressOptions = res || []

        this.addressOptions = addressOptions
      })
    },
    cancel() {
      this.visble = false
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let query = {...this.queryForm}
          if (query.upper_dealer_id === '') {
            delete query.upper_dealer_id
          }

          const { addressData } = this.queryForm
          query.province = addressData[0] || undefined
          query.city = addressData[1] || undefined
          query.area = addressData[2] || undefined
          delete query.addressData

          this.$request('post', createDealer, query).then((res) => {
            if (res) {
              this.$message.success(`操作成功`)
              this.visble = false
              this.$emit('success')
            }
          })
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped></style>
